import React from 'react';
import { Row, Col, FormGroup, Label, Input } from 'reactstrap';

const FieldFilters = ({ typeFilter, setTypeFilter, statusFilter, setStatusFilter }) => {
  return (
    <Row className="mt-4">
      <Col md="6">
        <FormGroup>
          <Label>Lọc theo loại</Label>
          <Input 
            type="select" 
            value={typeFilter}
            onChange={(e) => setTypeFilter(e.target.value)}
            className="border-0 shadow-sm"
          >
            <option value="all">Tất cả</option>
            <option value="text">Text</option>
            <option value="email">Email</option>
            <option value="number">Number</option>
            <option value="select">Select</option>
            <option value="checkbox">Checkbox</option>
            <option value="radio">Radio</option>
            <option value="textarea">Textarea</option>
            <option value="date">Date</option>
          </Input>
        </FormGroup>
      </Col>
      <Col md="6">
        <FormGroup>
          <Label>Lọc theo trạng thái</Label>
          <Input 
            type="select"
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
            className="border-0 shadow-sm"
          >
            <option value="all">Tất cả</option>
            <option value="active">Đang hoạt động</option>
            <option value="inactive">Không hoạt động</option>
          </Input>
        </FormGroup>
      </Col>
    </Row>
  );
};

export default FieldFilters;

